module.exports = __webpack_public_path__ + "static/media/icon-task.aed4f2fb.svg";